import { useEffect } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { KiralamaDetayIcerik } from './kiralama-detay-icerik.js';

export interface KiralamaDetayPenceresiOzellikleri {
  kiralamaId: string | null | undefined;
  onKapat: () => void;
}

export function KiralamaDetayPenceresi({ kiralamaId, onKapat }: KiralamaDetayPenceresiOzellikleri) {
  const acik = !!kiralamaId;

  useEffect(() => {
    if (!acik) return;
    const onPopState = () => onKapat();
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [acik, onKapat]);

  return (
    <Dialog.Root open={acik} onOpenChange={(o) => !o && onKapat()}>
      <Dialog.Portal>
        <Dialog.Overlay className="bg-fume-900/60 data-[state=open]:animate-in data-[state=open]:fade-in-0 fixed inset-0 z-40 backdrop-blur-sm" />
        <Dialog.Content
          className="bg-fume-50 dark:bg-fume-950 data-[state=open]:animate-in data-[state=open]:fade-in-0 fixed inset-0 z-50 flex flex-col sm:inset-4 sm:rounded-2xl sm:shadow-2xl"
          aria-describedby={undefined}
        >
          <div className="border-fume-200 dark:border-fume-800 dark:bg-fume-900/80 sticky top-0 z-10 flex items-center justify-between border-b bg-white/95 px-4 py-3 backdrop-blur sm:rounded-t-2xl sm:px-6">
            <Dialog.Title className="text-fume-500 dark:text-fume-400 text-sm font-medium">
              Kiralama Detay
            </Dialog.Title>
            <Dialog.Close asChild>
              <button
                onClick={onKapat}
                aria-label="Kapat"
                className="text-fume-500 hover:bg-fume-100 hover:text-fume-900 dark:text-fume-300 dark:hover:bg-fume-800 dark:hover:text-fume-50 grid h-9 w-9 place-items-center rounded-lg transition-colors"
              >
                <X size={18} />
              </button>
            </Dialog.Close>
          </div>

          <div className="flex-1 overflow-y-auto p-4 sm:p-6 md:p-8">
            <div className="mx-auto max-w-[1440px]">
              {kiralamaId && <KiralamaDetayIcerik kiralamaId={kiralamaId} />}
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
